module.exports = __webpack_public_path__ + "img/icon-figma.a41e84a4.svg";